<template>
  <div class="top-nav">
    <span class="topleft">
     <back-button cssClass="reverse"></back-button>
    </span>

    <small class="small-caps">{{ title }}</small>

    <span class="topright">
      <help-button cssClass="reverse"></help-button>
    </span>
  </div>
</template>

<script>

export default {
  name: 'BottomNav',
  components: { },
  props: {
    title:{
      type:String,
      default:''
    }
  }
}
</script>
<style lang="scss" scoped>
  .top-nav {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    > span {
      display: flex;
      &.topleft {
        justify-content: flex-start;
      }
      &.topright {
        justify-content: flex-end;
      }
      flex: 2;
    }
    .small-caps {
      margin-top: 15px;
      letter-spacing: 2px;
      // prevent collapse...
      min-height:21px;
    }
  }
</style>
